import config from "@/config";
import { createTranslator } from "@filmin/translations";

const general =
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  require(`@/translations/${config.LOCALE}/general.json`);
const premieres =
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  require(`@/translations/${config.LOCALE}/premieres.json`);

const translator = createTranslator();
translator.addKeys(general);
translator.addKeys(premieres);
export default translator;
export const trans = translator.trans;
export const transChoice = translator.transChoice;
